import { parseSuccessfulResponse, RequestSender } from "./helpers";

export type ManualPurchaseShippingAddress = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
};

export type CreateManualPurchaseInput = {
  parentEmail?: string;
  parentId?: string;
  products: string[];
  source?: string;
  months?: number;
  purchaseName?: string;
  purchaseGroupId?: string;
  dryRun?: boolean;
  shippingAddress?: ManualPurchaseShippingAddress;
};

export type CreateManualPurchaseResult = {
  parentId: string;
  parentEmail: string;
  purchaseGroupId?: string;
  purchaseName?: string;
  source?: string;
  result?: {
    autoAssigned: boolean;
    needStudentCreation: boolean;
    unassignedSlots: number;
  };
  outbox?: Array<{
    eventType: string;
    eventId: string;
    status: string;
  }>;
  manualPurchase?: {
    purchaseGroupId: string;
    purchaseName: string;
    digitalItems: Array<{
      entitlementType: string;
      productName: string;
      source: string;
      purchaseGroupId: string;
      quantity: number;
      months: number;
    }>;
    physicalItems: Array<{
      entitlementType: string;
      productName: string;
      source: string;
      purchaseGroupId: string;
      quantity: number;
      shippingAddress: ManualPurchaseShippingAddress | null;
    }>;
    months: number;
  };
  note?: string;
};

async function createManualPurchase(
  request: RequestSender,
  input: CreateManualPurchaseInput,
) {
  const response = await request("post", "/admin/manual-purchase", input);

  if (response.data.message !== "success") {
    throw new Error(response.data.message);
  }

  return parseSuccessfulResponse<CreateManualPurchaseResult>(
    response,
    (d) => d,
  );
}

export default createManualPurchase;
